/**
 * Ex data
 * TODO: Load from database
 */

import manufacturingOrder from "../../data/manufacturingOrder";
import articles from "../../data/articles";
import processDesign from "../../data/processDesign";

manufacturingOrder.data.map(obj => {
  obj.article = articles.data.find(art => art.id === obj.articleId);
  if(obj.desingId) obj.desing = processDesign.data.find(dsg => dsg.id === obj.desingId);
  return obj;
});

const INITIAL_STATE = {
  data: manufacturingOrder.data
};

const loadManufacturingOrderReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "CHANGE_DESING":
      return {
        ...state,
        data: [...state.data.map(d => (d.id === action.manufacturingOrder.id ? action.manufacturingOrder : d))]
      };
      //return { ...state, data: [...state.data, action.manufacturingOrder] };
    case "UPDATE_PIECE_STATUS":
      return {
        ...state,
        data: [...state.data.map(d => (d.id === action.manufacturingOrder.id ? action.manufacturingOrder.pieces : d.pieces))]
      };
    case "DELETE_DESING":
      return {
        ...state,
        data: [...state.data.filter(d => d.id !== action.state.id)]
      };
    default:
      return state;
  }
};

export default loadManufacturingOrderReducer;
